export default {
  //hostname: "http://localhost:5004",
  hostname: "https://api.kuncikerja.com",
};
